/**
 * Environment Variable Utility
 *
 * Uses Vite's build-time injection (import.meta.env.VITE_*).
 * Variables are baked into the bundle during build.
 */

export const env = {
    api: {
        PRODUCT_BACKEND_URL: import.meta.env.VITE_PRODUCT_BACKEND_URL,
        ORDER_MGMT_API_URL: import.meta.env.VITE_ORDER_MGMT_API_URL,
    },
    oauth2: {
        serverUrl: import.meta.env.VITE_OAUTH2_URL || '',
        clientId: import.meta.env.VITE_OAUTH2_CLIENT_ID || '',
        redirectUri: import.meta.env.VITE_OAUTH2_REDIRECT_URI || '',
        scope: import.meta.env.VITE_OAUTH2_SCOPE || 'openid profile email',
        organizationId: import.meta.env.VITE_OAUTH2_ORGANIZATION_ID || '',
    },
    COMPANY_NAME: import.meta.env.VITE_COMPANY_NAME || 'EcomStore',
    LOGO_URL: import.meta.env.VITE_LOGO_URL || '',
    COD_ENABLED: import.meta.env.VITE_COD_ENABLED === 'true',
    PAYMENT_GATEWAY: import.meta.env.VITE_PAYMENT_GATEWAY || '',
    ENABLE_DARK_MODE: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',
    CDN_BASE_URL: import.meta.env.VITE_CDN_BASE_URL || '',
    STRIPE_PUBLIC_KEY: import.meta.env.VITE_STRIPE_PUBLIC_KEY || '',
    RAZORPAY_KEY_ID: import.meta.env.VITE_RAZORPAY_KEY_ID || '',
    FREE_SHIPPING_THRESHOLD: parseFloat(import.meta.env.VITE_FREE_SHIPPING_THRESHOLD || '100'),
    FLAT_SHIPPING_COST: parseFloat(import.meta.env.VITE_FLAT_SHIPPING_COST || '15'),
};
